module.exports = __webpack_public_path__ + "img/beer_id-72.a34fbc95.png";